import { withUnmountTransition } from '../../misc/withUnmountTransition.hoc'
import { AddDatamatrixModal } from './AddDatamatrixModal.component'

const withUnmountHoc = withUnmountTransition(AddDatamatrixModal)
export { withUnmountHoc as AddDatamatrixModal }
